type DataLayerEvent = Record<string, unknown>

declare global {
    interface Window {
        dataLayer: DataLayerEvent[]
    }
}

export const initGTM = () => {
    if (!process.env.REACT_APP_GTM_ID) {
        return
    }

    const gtmId = process.env.REACT_APP_GTM_ID

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
    })

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`

    document.head.appendChild(script)
}

export interface DataLayerEventParams {
    [key: string]: string | number | boolean | undefined
}

export const pushDataLayerEvent = (event: string, params?: DataLayerEventParams) => {
    if (!window.dataLayer) {
        return // GTM not initialized (REACT_APP_GTM_ID unset) -> no-op
    }
    window.dataLayer.push({ event, ...params })
}

export const pushUserId = (userId: string) => {
    if (!window.dataLayer || !userId) {
        return
    }
    window.dataLayer.push({ user_id: userId })
}
